import type { TimeRange } from "@@/shared/date-time/time-range";
import { getOverrideResource } from "../resource-references/resource-override";
import type { ResourceReference } from "../resource-references/resource-reference";
import { calculateResourceSchedule } from "../resource-references/schedule/calculate-resource-schedule";
import type { ResourceId } from "../resources/resource-id";
import type { BookableSession } from "./bookable-session";

type ResourceTimeRange = {
    resourceId: ResourceId;
    timeRanges: TimeRange[];
};

const generateResourceTimeRanges = (
    timeRange: TimeRange,
    current: ResourceReference,
    session?: BookableSession,
) => {
    const resource = getOverrideResource(session, current);
    if (current.schedulingResource) {
        const times = calculateResourceSchedule(
            current.schedulingResource,
            timeRange,
        );

        return {
            resourceId: resource._id,
            timeRanges: times,
        } as ResourceTimeRange;
    }

    return {
        resourceId: resource._id,
        timeRanges: [timeRange],
    } as ResourceTimeRange;
};
export { generateResourceTimeRanges };
export type { ResourceTimeRange };
